import { Injectable } from '@angular/core';
import { HttpHeadersService } from '../../core/shared-service/http-headers.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

/**
 * Service
 */
@Injectable({
  providedIn: 'root'
})
export class CountriesService {
  private _countries = new Map<string, string>();
  private _timezones = new Map<string, string>();

  constructor(
    private httpclient: HttpClient,
    private httpHeaderService: HttpHeadersService
  ) { }

  get() {
    const headers = this.httpHeaderService.preLoginHttpAuthorizationHeader();
    this.httpclient.get(environment.servicePath + '/address/countries_timezones', { headers }).subscribe(
      (res: ICountriesAndTimezoneResponse) => {
        // countries map
        res.countries.map(country => {
          this._countries.set(country.isoCountryCode, country.name)
        });

        //timezone map
        res.timezoneList.map(timezone => {
          this._timezones.set(timezone.name, timezone.timezone)
        });
      },
      (err: any) => console.error('Country list API failed.')
    );
  }

  getCountry(isoCountryCode: string) {
    return this._countries.get(isoCountryCode);
  }


}



/**
 * Interfaces
 */
interface ICountriesAndTimezoneResponse {
  countries: ICountry[];
  timezoneList: ITimezone[];
}

interface ICountry {
  id: string;
  name: string;
  isoCountryCode: string;
}

interface ITimezone {
  name: string;
  timezone: string;
}
